<div class="booking-modal-overlay" *ngIf="isOpen" (click)="closeModal()">
  <div class="booking-modal-container" (click)="$event.stopPropagation()">
    
    <!-- Close Button -->
    <button class="modal-close-btn" (click)="closeModal()" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>

    <!-- Success State -->
    <div class="success-state" *ngIf="submitSuccess">
      <div class="success-icon">
        <i class="bi bi-check-circle-fill"></i>
      </div>
      <h2>Request Received!</h2>
      <p>{{ submitMessage }}</p>
      <div class="success-animation">
        <div class="checkmark-circle">
          <div class="checkmark draw"></div>
        </div>
      </div>
    </div>

    <!-- Form Content -->
    <div class="modal-content" *ngIf="!submitSuccess">
      
      <!-- Header -->
      <div class="modal-header">
        <h2 class="modal-title">Book Your Free Consultation</h2>
        <p class="modal-subtitle">Takes less than 30 seconds, we'll handle the rest</p>
      </div>

      <!-- Progress Bar -->
      <div class="progress-wrapper">
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="getProgressPercentage()"></div>
        </div>
        <div class="progress-steps">
          <div *ngFor="let step of steps" 
               class="progress-step"
               [class.active]="currentStep === step.id"
               [class.completed]="currentStep > step.id"
               (click)="goToStep(step.id)">
            <div class="step-circle">
              <i [class]="step.icon" *ngIf="currentStep <= step.id"></i>
              <i class="bi bi-check-lg" *ngIf="currentStep > step.id"></i>
            </div>
            <span class="step-label">{{ step.title }}</span>
          </div>
        </div>
      </div>

      <!-- Form Steps -->
      <form [formGroup]="bookingForm" (ngSubmit)="onSubmit()" class="booking-form">
        
        <!-- Step 1: Service Selection -->
        <div class="form-step" *ngIf="currentStep === 1">
          <div class="step-header">
            <h3>{{ steps[0].title }}</h3>
            <p>{{ steps[0].subtitle }}</p>
          </div>
          
          <div class="service-grid">
            <div *ngFor="let service of services" 
                 class="service-card"
                 [class.selected]="bookingForm.get('service')?.value === service.id"
                 (click)="selectService(service.id)">
              <i [class]="service.icon"></i>
              <span>{{ service.name }}</span>
            </div>
          </div>
          
          <div class="error-message" *ngIf="isFieldInvalid('service')">
            Please select a service
          </div>
        </div>

        <!-- Step 2: Personal Details (Final Step) -->
        <div class="form-step" *ngIf="currentStep === 2">
          <div class="step-header">
            <h3>{{ steps[1].title }}</h3>
            <p>{{ steps[1].subtitle }}</p>
          </div>

          <!-- Selected Service Badge (shown when service is pre-filled) -->
          <div class="selected-service-badge" *ngIf="preselectedServiceId">
            <i class="bi bi-check-circle-fill"></i>
            <span>{{ getSelectedServiceName() }}</span>
            <button type="button" class="change-link" (click)="changeService()">Change</button>
          </div>

          <div class="form-grid">
            <div class="form-group full-width">
              <label for="fullName">Full Name *</label>
              <input 
                type="text" 
                id="fullName" 
                formControlName="fullName"
                class="form-control"
                [class.invalid]="isFieldInvalid('fullName')"
                placeholder="John Doe">
              <span class="error-message" *ngIf="isFieldInvalid('fullName')">
                {{ getErrorMessage('fullName') }}
              </span>
            </div>

            <div class="form-group">
              <label for="email">Email Address *</label>
              <input 
                type="email" 
                id="email" 
                formControlName="email"
                class="form-control"
                [class.invalid]="isFieldInvalid('email')"
                placeholder="john&#64;example.com">
              <span class="error-message" *ngIf="isFieldInvalid('email')">
                {{ getErrorMessage('email') }}
              </span>
            </div>

            <div class="form-group">
              <label for="phone">Phone Number *</label>
              <input 
                type="tel" 
                id="phone" 
                formControlName="phone"
                class="form-control"
                [class.invalid]="isFieldInvalid('phone')"
                placeholder="+1 234 567 890">
              <span class="error-message" *ngIf="isFieldInvalid('phone')">
                {{ getErrorMessage('phone') }}
              </span>
            </div>

            <div class="form-group full-width">
              <label for="message">Tell Us About Your Project <span class="optional-tag">(Optional)</span></label>
              <textarea 
                id="message" 
                formControlName="message"
                class="form-control"
                rows="3"
                placeholder="Tell us briefly about your project or any questions..."></textarea>
            </div>
          </div>
        </div>

        <!-- Navigation Buttons (Step 2 only) -->
        <div class="form-navigation" *ngIf="currentStep > 1">
          <button 
            type="button" 
            class="btn-secondary"
            *ngIf="currentStep > 1"
            (click)="previousStep()">
            <i class="bi bi-arrow-left"></i>
            Back
          </button>

          <button 
            type="submit" 
            class="btn-primary btn-submit"
            *ngIf="currentStep === totalSteps"
            [disabled]="isSubmitting">
            <span *ngIf="!isSubmitting">
              <i class="bi bi-check-circle"></i>
              Book Consultation
            </span>
            <span *ngIf="isSubmitting">
              <i class="bi bi-hourglass-split spin"></i>
              Submitting...
            </span>
          </button>
        </div>

        <!-- Error banner for submit failures -->
        <div class="submit-error" *ngIf="submitMessage && !submitSuccess">
          <i class="bi bi-exclamation-triangle"></i>
          <span>{{ submitMessage }}</span>
        </div>
      </form>

      <!-- Trust Badges -->
      <div class="trust-section">
        <div class="trust-badge">
          <i class="bi bi-shield-check"></i>
          <span>100% Secure</span>
        </div>
        <div class="trust-badge">
          <i class="bi bi-clock-history"></i>
          <span>2 Hour Response</span>
        </div>
        <div class="trust-badge">
          <i class="bi bi-x-circle"></i>
          <span>No Obligation</span>
        </div>
      </div>
    </div>
  </div>
</div>
